import type { ApiDataTransformer } from '@kiplin/web-common/architecture-core';
import { injectable } from 'inversify';
import type { CurrentUserApiData } from '@shared/entity/current-user/data/api-data/current-user.api-data';
import { CurrentUser } from '@shared/entity/current-user/domain/model/current-user.model';

@injectable()
export class CurrentUserApiDataTransformer implements ApiDataTransformer<CurrentUserApiData, CurrentUser> {
  map(data: CurrentUserApiData): CurrentUser {
    return new CurrentUser(data.id, data.email, data.firstname, data.lastname);
  }
}
